import axiosClient from "./axiosClient.js";
import ROUTES from "../constants/routes.js";

const Payments = {
  create(data) {
    return axiosClient.post(ROUTES.CREATE_PAYMENT, data);
  },

  getById(id) {
    return axiosClient.get(`${ROUTES.CREATE_PAYMENT}/${id}`);
  }
};

export default Payments;
